import * as angular from "angular";

angular
  .module('bringoz.admin.commons')
  .filter('shortenedText', shortenedTextFilter);

function shortenedTextFilter() {
  return function shortenedText(text: string, maxChars: number,showEnd:boolean): string {
    let changedText = text;

    if (changedText.length > maxChars) {
      changedText = showEnd? changedText.slice(-maxChars, -1).concat('...') :changedText.slice(0, maxChars).concat('...');
    }
    return changedText;

  };
}
